// These bytes in the "data" field of an IPFS node indicate that the node is an IPLD DAG Node
export const DAG_NODE_DATA = new Uint8Array([8, 1])

export default {
  DAG_NODE_DATA
}
